import parsePhoneNumber from 'libphonenumber-js';

// Validate phone number format
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (countryCode === 'sa' && !/^9665\d{8}$/.test(phoneNumber)) {
  return false;
}
  const phone = parsePhoneNumber('+' + phoneNumber, countryCode);
  
  return phone && phone.isValid();
};

// Validate email format using a simple regex
export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

// Validate required fields
export const validateRequired = (value) => {
  return value && value.trim() !== '';
};


// Main validation function
export const validateForm = (fields, formData) => {
  console.log('fields: ', fields);
  console.log('formData: ', formData);

  let errorMessage = '';
  let hasGenericMessage = false;

  // Step 1: General validations for required fields
  fields.forEach((field) => {
    // Step 1: Handle dependent fields (skip if not rendered
    if (field.dependentOn) {
      const dependentValue = formData[field.dependentOn];
      if (!field.dependencyValues.includes(dependentValue)) {
        return; // Skip this field and continue with the next iteration
      }
    }

    const fieldId = field.id;
    const value = formData[fieldId];
    const isRequired = field.required;

    console.log('.. ', fieldId, ' ', value, ' ', isRequired);

    // Skip validation for social media platform fields (instagram, twitter, etc.)
    if (['instagram', 'x', 'tiktok', 'snapchat'].includes(fieldId)) {
      return; // Skip these fields
    }


    // For other required fields
    if (isRequired && !value && !hasGenericMessage) {
      errorMessage += '\nيرجى إدخال جميع الحقول المطلوبة\n';
      hasGenericMessage = true;
    }
  });

  
     // Specific validation for the socialMediaAccount field
     const socialMedia = formData['socialMedia']; // Get the selected social media platform
     const socialMediaAccount = formData['socialMediaAccount']; // Get the value of socialMediaAccount
   
     // If a social media platform is selected, socialMediaAccount should not be empty
     if (socialMedia && !socialMediaAccount) {
       errorMessage +=`يرجى إدخال حسابك في ${socialMedia}\n`; // "Please enter a social media account"
     }
  // Specific validations for mobile and email
  const { mobile, countryCode, email } = formData;

  if (mobile && countryCode && !validatePhoneNumber(mobile, countryCode)) {
    errorMessage += 'يجب إدخال رقم الجوال بشكل صحيح\n';
  }

  if (email && !validateEmail(email)) {
    errorMessage += 'البريد الإلكتروني غير صالح\n';
  }

  return errorMessage.trim(); // Return the accumulated error messages
};
